import logoNoronCar from '../Images/logo.png';
import config from "../config.json";
import "./Register.css";
import loginLogo from '../Images/logoWeb.png';
import React, { useContext, useEffect, useState, useRef } from "react";
import AddImage from '../Images/AddImage.png';
import { Link } from 'react-router-dom';
import http from "../Services/httpService";
import service from "../Services/services";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';

export default function PersonData() {
    let navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const backgroundCardMeli = useRef(null);
    const picCardMeli = useRef(null);

    const backgroundCode = useRef(null);
    const picCode = useRef(null);

    const backgroundMovafegh = useRef(null);
    const picMovafegh = useRef(null);

    const backgroundPersoneli = useRef(null);
    const picPersoneli = useRef(null);

    const [form, setForm] = useState({ id: 0, name: "", family: "" });
    const loadData = async () => {
        setIsLoading(true);
        await service.OzveGet()
            .then(({ data }) => {
                setIsLoading(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                setForm(data.payload);
            })
            .catch(err => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (!jwt || jwt == "") {
            navigate('/login');
            return;
        }
        loadData();
    }, []);

    useEffect(() => {
        if (isLoading || form.id <= 0)
            return;
        // console.log('111');
        // console.log('111',backgroundPersoneli);
        if (backgroundPersoneli.current) {
            backgroundPersoneli.current.style.backgroundImage = `url(${config.apiUrl}/picture/${form.id}.jpg?${new Date().getTime()})`;
        }
        //backgroundPersoneli.current.style.backgroundImage = `url(${config.apiUrl}/api/kanon/WebOzve/GetPic?id=${form.id}&${new Date().getTime()})`;
        //console.log('222');
        if (backgroundCardMeli.current) {
            backgroundCardMeli.current.style.backgroundImage = `url(${config.apiUrl}/picture/${form.id}_0.jpg?${new Date().getTime()})`;
        }
        //backgroundCardMeli.current.style.backgroundImage = `url(${config.apiUrl}/api/kanon/WebOzve/GetPic?id=${form.id}_0&${new Date().getTime()})`;
        if (backgroundCode.current) {
            backgroundCode.current.style.backgroundImage = `url(${config.apiUrl}/picture/${form.id}_1.jpg?${new Date().getTime()})`;
        }
        //backgroundCode.current.style.backgroundImage = `url(${config.apiUrl}/api/kanon/WebOzve/GetPic?id=${form.id}_1&${new Date().getTime()})`;
        if (backgroundMovafegh.current) {
            backgroundMovafegh.current.style.backgroundImage = `url(${config.apiUrl}/picture/${form.id}_2.jpg?${new Date().getTime()})`;
        }
        //backgroundMovafegh.current.style.backgroundImage = `url(${config.apiUrl}/api/kanon/WebOzve/GetPic?id=${form.id}_2&${new Date().getTime()})`;
    }, [isLoading, form.id]);

    const formRef = useRef(null);

    return (
        <div className="container-fluid bg-light min-vh-100 py-3 py-md-4" dir="rtl">
            <div className="container" style={{ maxWidth: '960px' }}>
                
                {/* بخش هدر و لوگو */}
                <div className="row justify-content-center text-center mb-3">
                    <div className="col-12">
                        <img 
                            src={loginLogo} 
                            className="img-fluid mb-2" 
                            alt="logoRegister" 
                            style={{ maxHeight: '75px', objectFit: 'contain' }} 
                        />
                        <h1 className="h5 fw-bold text-primary mb-1">
                            🏛️ کانون بازنشستگان استان همدان
                        </h1>
                        <p className="text-secondary small mb-0">مشاهده مشخصات فردی و پرونده عضویت</p>
                    </div>
                </div>

                {/* وضعیت بارگذاری */}
                {isLoading && (
                    <div className="d-flex flex-column align-items-center justify-content-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <span className="text-muted small mt-2">در حال دریافت مشخصات...</span>
                    </div>
                )}

                {!isLoading && (
                    <form ref={formRef} className="card shadow-sm border-0 rounded-4 p-3 p-md-4 needs-validation bg-white">
                        
                        {/* بخش اول: مشخصات هویتی و پرونده */}
                        <div className="d-flex align-items-center gap-2 pb-2 mb-3 border-bottom text-dark">
                            <span className="fs-5">🪪</span>
                            <span className="fw-bold">اطلاعات هویتی و بازنشستگی</span>
                        </div>

                        <div className="row g-3 mb-4">
                            <div className="col-12 col-sm-6 col-lg-4">
                                <label className="form-label small fw-semibold text-secondary">نام</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0 text-muted">👤</span>
                                    <input disabled
                                        type="text"
                                        className="form-control bg-light border-start-0 text-dark fw-bold"
                                        value={form.name || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="name" />
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-lg-4">
                                <label className="form-label small fw-semibold text-secondary">نام خانوادگی</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0 text-muted">👥</span>
                                    <input disabled
                                        type="text"
                                        className="form-control bg-light border-start-0 text-dark fw-bold"
                                        value={form.family || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="family" />
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-lg-4">
                                <label className="form-label small fw-semibold text-secondary">نام پدر</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0 text-muted">👨</span>
                                    <input disabled
                                        type="text"
                                        className="form-control bg-light border-start-0 text-dark fw-bold"
                                        value={form.nameFather || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="nameFather" />
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-lg-4">
                                <label className="form-label small fw-semibold text-secondary">کد ملی</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0 text-muted">🔢</span>
                                    <input disabled
                                        type="number"
                                        className="form-control bg-light border-start-0 text-dark fw-bold"
                                        value={form.codeMeli || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="codeMeli" />
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-lg-4">
                                <label className="form-label small fw-semibold text-secondary">شماره شناسنامه</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0 text-muted">📄</span>
                                    <input disabled
                                        type="number"
                                        className="form-control bg-light border-start-0 text-dark fw-bold"
                                        value={form.code || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="code" />
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-lg-4">
                                <label className="form-label small fw-semibold text-secondary">سریال شناسنامه</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0 text-muted">🔖</span>
                                    <input disabled
                                        type="text"
                                        className="form-control bg-light border-start-0 text-dark fw-bold"
                                        value={form.seriall || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="seriall" />
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-lg-4">
                                <label className="form-label small fw-semibold text-secondary">تاریخ تولد</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0 text-muted">📅</span>
                                    <input disabled
                                        type="text"
                                        className="form-control bg-light border-start-0 text-dark fw-bold"
                                        value={form.birthDay || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="birthDay" />
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-lg-4">
                                <label className="form-label small fw-semibold text-secondary">شماره مستمری</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0 text-muted">💳</span>
                                    <input disabled
                                        type="number"
                                        className="form-control bg-light border-start-0 text-primary fw-bold"
                                        value={form.mostamariCode || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="mostamariCode" />
                                </div>
                            </div>
                        </div>

                        {/* بخش دوم: اطلاعات تماس و آدرس */}
                        <div className="d-flex align-items-center gap-2 pb-2 mb-3 border-bottom text-dark">
                            <span className="fs-5">📞</span>
                            <span className="fw-bold">اطلاعات تماس و سکونت</span>
                        </div>

                        <div className="row g-3 mb-4">
                            <div className="col-12 col-sm-6">
                                <label className="form-label small fw-semibold text-secondary">شماره موبایل</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0 text-muted">📱</span>
                                    <input disabled
                                        type="number"
                                        className="form-control bg-light border-start-0 text-dark fw-bold text-end"
                                        value={form.mobile || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="mobile" />
                                </div>
                            </div>

                            <div className="col-12 col-sm-6">
                                <label className="form-label small fw-semibold text-secondary">تلفن ثابت</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0 text-muted">☎️</span>
                                    <input disabled
                                        type="number"
                                        className="form-control bg-light border-start-0 text-dark fw-bold text-end"
                                        value={form.telfix || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="telfix" />
                                </div>
                            </div>

                            <div className="col-12">
                                <label className="form-label small fw-semibold text-secondary">آدرس محل سکونت</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0 text-muted align-items-start pt-2">📍</span>
                                    <textarea
                                        disabled
                                        rows="3"
                                        className="form-control bg-light border-start-0 text-dark"
                                        value={form.address || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="address" />
                                </div>
                            </div>
                        </div>

                        {/* بخش سوم: تصاویر مدارک */}
                        <div className="d-flex align-items-center gap-2 pb-2 mb-3 border-bottom text-dark">
                            <span className="fs-5">🖼️</span>
                            <span className="fw-bold">مدارک و تصاویر پرسنلی</span>
                        </div>

                        <div className="row g-3">
                            {/* تصویر عکس پرسنلی */}
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div 
                                    className="border rounded-3 p-3 bg-light shadow-sm text-center d-flex flex-column justify-content-end position-relative"
                                    style={{ 
                                        minHeight: "190px", 
                                        backgroundSize: "cover", 
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat"
                                    }}
                                    ref={backgroundPersoneli}
                                >
                                    <input disabled
                                        accept="image/*"
                                        className="d-none"
                                        type="file"
                                        //onChange={(e) => { upload(e, backgroundPersoneli, "personeliPic") }}
                                        ref={picPersoneli}
                                    />
                                    <div>
                                        <Link
                                            to=""
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                // picPersoneli.current.click()
                                            }}>
                                            {/*<img src={AddImage} />*/}
                                        </Link>
                                    </div>
                                    <div className="bg-dark bg-opacity-75 text-white rounded py-1 px-2 small fw-bold mt-auto">
                                        👤 عکس پرسنلی
                                    </div>
                                </div>
                            </div>

                            {/* تصویر کارت ملی */}
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div 
                                    className="border rounded-3 p-3 bg-light shadow-sm text-center d-flex flex-column justify-content-end position-relative"
                                    style={{ 
                                        minHeight: "190px", 
                                        backgroundSize: "cover", 
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat"
                                    }}
                                    ref={backgroundCardMeli}
                                >
                                    <input disabled
                                        accept="image/*"
                                        className="d-none"
                                        type="file"
                                        //onChange={(e) => { upload(e, backgroundCardMeli, "cardMeliPic") }}
                                        ref={picCardMeli}
                                    />
                                    <div>
                                        <Link
                                            to=""
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                //   picCardMeli.current.click()
                                            }}>
                                            {/*<img src={AddImage} />*/}
                                        </Link>
                                    </div>
                                    <div className="bg-dark bg-opacity-75 text-white rounded py-1 px-2 small fw-bold mt-auto">
                                        🪪 تصویر کارت ملی
                                    </div>
                                </div>
                            </div>

                            {/* تصویر شناسنامه */}
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div 
                                    className="border rounded-3 p-3 bg-light shadow-sm text-center d-flex flex-column justify-content-end position-relative"
                                    style={{ 
                                        minHeight: "190px", 
                                        backgroundSize: "cover", 
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat"
                                    }}
                                    ref={backgroundCode}
                                >
                                    <input disabled
                                        accept="image/*"
                                        className="d-none"
                                        type="file"
                                        // onChange={(e) => { upload(e, backgroundCode, "codePic") }}
                                        ref={picCode}
                                    />
                                    <div>
                                        <Link
                                            to=""
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                //  picCode.current.click()
                                            }}>
                                            {/*<img src={AddImage} />*/}
                                        </Link>
                                    </div>
                                    <div className="bg-dark bg-opacity-75 text-white rounded py-1 px-2 small fw-bold mt-auto">
                                        📄 تصویر شناسنامه
                                    </div>
                                </div>
                            </div>

                            {/* تصویر حکم بازنشستگی */}
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div 
                                    className="border rounded-3 p-3 bg-light shadow-sm text-center d-flex flex-column justify-content-end position-relative"
                                    style={{ 
                                        minHeight: "190px", 
                                        backgroundSize: "cover", 
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat"
                                    }}
                                    ref={backgroundMovafegh}
                                >
                                    <input disabled
                                        accept="image/*"
                                        className="d-none"
                                        type="file"
                                        //onChange={(e) => { upload(e, backgroundMovafegh, "movafeghPic") }}
                                        ref={picMovafegh}
                                    />
                                    <div>
                                        <Link
                                            to=""
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                //picMovafegh.current.click()
                                            }}>
                                            {/*<img src={AddImage} />*/}
                                        </Link>
                                    </div>
                                    <div className="bg-dark bg-opacity-75 text-white rounded py-1 px-2 small fw-bold mt-auto">
                                        📜 حکم بازنشستگی
                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>
                )}

                {/* دکمه بازگشت با دکمه و بج‌های Bootstrap */}
                <div className="row mt-4 mb-3">
                    <div className="col d-flex justify-content-center">
                        <Link 
                            to="/main" 
                            className="btn btn-outline-primary d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm text-decoration-none fw-bold"
                        >
                            <img 
                                src={logoNoronCar} 
                                className="img-fluid rounded-circle shadow-sm" 
                                style={{ width: '28px', height: '28px', objectFit: 'contain' }} 
                                alt="logoWeb" 
                            />
                            <span>بازگشت به صفحه اصلی</span>
                            <span>➜</span>
                        </Link>
                    </div>
                </div>

            </div>
        </div>
    );
}
